module.exports = __webpack_public_path__ + "static/media/keymore.1800bc39.png";